import { CaseType, Status } from '../services/cases/types/ICase';
import { UserRoleName } from '../services/identity/types/UserProfile';

export const getTextForStatus = (userRole: string, caseType: string, status: Status): string => {
  if (userRole === UserRoleName.CareAdvisor || userRole === UserRoleName.Collector) {
    if (
      caseType === CaseType.one_report ||
      caseType === CaseType.video_call_instant ||
      caseType === CaseType.video_call_scheduled ||
      caseType === CaseType.phone_call_scheduled ||
      caseType === CaseType.second_opinion ||
      caseType === CaseType.smile_scan ||
      caseType === CaseType.care_coordination ||
      caseType === CaseType.oral_health_coaching ||
      caseType === CaseType.clinical_enablement
    ) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'New';
        case Status.AcceptedCareAdvisor:
          return 'Accepted';
        case Status.AcceptedProvider:
          return 'Assigned';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.InProgressProvider:
          return 'With Provider';
        case Status.InProgressCareAdvisor:
          return 'In progress';
        case Status.Completed:
          return 'Completed';
        case Status.Canceled:
          return 'Canceled';
        default:
          return '';
      }
    } else if (caseType === CaseType.messaging) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'New';
        case Status.AcceptedCareAdvisor:
          return 'Accepted';
        case Status.InProgressCareAdvisor:
          return 'In progress';
        case Status.Completed:
          return 'Completed';
        case Status.Canceled:
          return 'Canceled';
        default:
          return '';
      }
    }
  } else if (userRole === UserRoleName.Provider) {
    if (
      caseType === CaseType.one_report ||
      caseType === CaseType.video_call_instant ||
      caseType === CaseType.second_opinion ||
      caseType === CaseType.smile_scan ||
      caseType === CaseType.video_call_scheduled ||
      caseType === CaseType.phone_call_scheduled ||
      caseType === CaseType.care_coordination ||
      caseType === CaseType.oral_health_coaching ||
      caseType === CaseType.clinical_enablement
    ) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'New';
        case Status.AcceptedCareAdvisor:
          return 'Accepted Care Advisor';
        case Status.AcceptedProvider:
          return 'Assigned';
        case Status.InProgressProvider:
          return 'In progress';
        case Status.InProgressCareAdvisor:
          return 'With Care Advisor';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.Completed:
          return 'Completed';
        case Status.Canceled:
          return 'Canceled';
        default:
          return '';
      }
    }
  } else if (userRole === UserRoleName.Patient) {
    if (caseType === CaseType.one_report || caseType === CaseType.second_opinion || caseType === CaseType.smile_scan) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'Requested';
        case Status.AcceptedCareAdvisor:
          return 'Dentist Pending';
        case Status.AcceptedProvider:
          return 'Dentist Assigned';
        case Status.InProgressProvider:
          return 'Report In Progress';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.InProgressCareAdvisor:
          return 'Report In Progress';
        case Status.Completed:
          return 'Appointment completed';
        case Status.Canceled:
          return 'Appointment canceled';
        default:
          return '';
      }
    } else if (caseType === CaseType.care_coordination) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'Requested';
        case Status.AcceptedCareAdvisor:
          return 'In progress';
        case Status.AcceptedProvider:
          return 'Dentist Assigned';
        case Status.InProgressProvider:
          return 'Report In Progress';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.InProgressCareAdvisor:
          return 'In progress';
        case Status.Completed:
          return 'Appointment completed';
        case Status.Canceled:
          return 'Appointment canceled';
        default:
          return '';
      }
    } else if (caseType === CaseType.oral_health_coaching) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'Requested';
        case Status.AcceptedCareAdvisor:
          return 'In progress';
        case Status.AcceptedProvider:
          return 'Dentist Assigned';
        case Status.InProgressProvider:
          return 'Report In Progress';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.InProgressCareAdvisor:
          return 'In progress';
        case Status.Completed:
          return 'Appointment completed';
        case Status.Canceled:
          return 'Appointment canceled';
        default:
          return '';
      }
    } else if (caseType === CaseType.video_call_instant) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'Requested';
        case Status.AcceptedCareAdvisor:
          return 'Dentist Pending';
        case Status.AcceptedProvider:
          return 'Dentist Assigned';
        case Status.InProgressProvider:
          return 'Dentist Assigned';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.InProgressCareAdvisor:
          return 'Report In Progress';
        case Status.Completed:
          return 'Appointment completed';
        case Status.Canceled:
          return 'Appointment canceled';
        default:
          return '';
      }
    } else if (caseType === CaseType.video_call_scheduled || caseType === CaseType.phone_call_scheduled) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'Requested';
        case Status.AcceptedCareAdvisor:
          return 'Dentist Pending';
        case Status.AcceptedProvider:
          return 'Scheduled';
        case Status.InProgressProvider:
          return 'In progress';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.InProgressCareAdvisor:
          return 'Report In Progress';
        case Status.Completed:
          return 'Appointment completed';
        case Status.Canceled:
          return 'Appointment canceled';
        default:
          return '';
      }
    }
  } else if (
    userRole === UserRoleName.Admin ||
    userRole === UserRoleName.SuperAdmin ||
    userRole === UserRoleName.OrganizationAdmin
  ) {
    if (
      caseType === CaseType.one_report ||
      caseType === CaseType.video_call_instant ||
      caseType === CaseType.video_call_scheduled ||
      caseType === CaseType.phone_call_scheduled ||
      caseType === CaseType.second_opinion ||
      caseType === CaseType.smile_scan ||
      caseType === CaseType.care_coordination ||
      caseType === CaseType.oral_health_coaching ||
      caseType === CaseType.clinical_enablement
    ) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'New';
        case Status.AcceptedCareAdvisor:
          return 'Accepted';
        case Status.AcceptedProvider:
          return 'Assigned';
        case Status.InProgressProvider:
          return 'With Provider';
        case Status.CompletedByProvider:
          return 'Completed By Provider';
        case Status.InProgressCareAdvisor:
          return 'In progress';
        case Status.Completed:
          return 'Completed';
        case Status.Canceled:
          return 'Canceled';
        default:
          return '';
      }
    } else if (caseType === CaseType.messaging) {
      switch (status) {
        case Status.Upcoming:
          return 'Upcoming';
        case Status.New:
          return 'New';
        case Status.AcceptedCareAdvisor:
          return 'Accepted';
        case Status.InProgressCareAdvisor:
          return 'In progress';
        case Status.Completed:
          return 'Completed';
        case Status.Canceled:
          return 'Canceled';
        default:
          return '';
      }
    }
  }
  return '';
};
